import { Component } from 'react';

/**
 * Why Still use class Component, caused by we need to pass ref in component without create new element/component
 */
export default class OverlayTarget extends Component {
  render() {
    return this.props.children;
  }
}
